import {
  Button,
  ButtonGroup,
  Row,
  Col,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Modal,
} from "reactstrap";

export default function UsedBuildingDetailsModal({
  isOpen,
  value,
  changeUsedBuildingDetails,
  setOpenModal,
  setValue,
  fieldName,
}) {
  return (
    <Modal
      isOpen={isOpen}
      fullscreen="sm"
      autoFocus={false}
      toggle={() => {
        setValue("");
        setOpenModal(false);
      }}
    >
      <ModalHeader>{fieldName}</ModalHeader>
      <ModalBody>
        <Input
          type="number"
          maxLength="40"
          autoFocus={true}
          value={value}
          onChange={(e) => setValue(e.target.valueAsNumber)}
        />
      </ModalBody>
      <ModalFooter>
        <Row className={"d-flex justify-content-end"}>
          <Col>
            <ButtonGroup className="float-end">
              <Button color="primary" onClick={changeUsedBuildingDetails}>
                Save
              </Button>
              <Button
                onClick={() => {
                  setValue("");
                  setOpenModal(false);
                }}
              >
                Close
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  );
}
